import dayjs from 'dayjs'
import SelectMonthRangeFilter from 'components/MTB/grid/SelectMonthRangeFilter'

export const customMonthRangeFilterOperators = [
  {
    label: 'within month',
    value: 'withinMonthRange',
    getApplyFilterFn: filterItem => {
      if (!filterItem.value || !Array.isArray(filterItem.value)) return null

      const [monthYear] = filterItem.value // '2025-07'
      if (!monthYear) return null

      const selectedMonth = dayjs(monthYear, 'YYYY-MM')
      const startOfMonth = selectedMonth.startOf('month')
      const endOfMonth = selectedMonth.endOf('month')

      return rowValue => {
        if (!Array.isArray(rowValue) || rowValue.length !== 2) return false

        const [start, end] = rowValue
        const startDate = dayjs(start)
        const endDate = dayjs(end)

        if (!startDate.isValid() || !endDate.isValid()) return false

        // ✅ Check if the selected month overlaps the row's date range
        return startDate.isBefore(endOfMonth) && endDate.isAfter(startOfMonth)
      }
    },
    InputComponent: SelectMonthRangeFilter,
    InputComponentProps: {
      type: 'date',
    },
  },
]
